import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout.js';
import * as General from '../General/General.js';
import { trackPromise } from 'react-promise-tracker';
// import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
// import { Modal } from "react-bootstrap";
import Delete from '../Delete/Delete.js';
import Modal_UpdateConfirm from './Modal_UpdateConfirm.js';
import Drp_ProductGroup from '../ProductGroup/Drp_Group.js';
import Drp_ProductParentGroup from '../ProductGroup/Drp_Group.js';
import Auto_Product from '../Product/Auto_Product.js';
import Drp_StoreRoom from '../StoreRoom/Drp_StoreRoom.js';
import moment from 'moment-jalaali';
import DatePicker from 'react-datepicker2';
import PN from "persian-number";



const RecieptIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    const rowKey = 'id';
    let navigate = useNavigate();
    const DeleteRef = useRef()
    const UpdateConfirmRef = useRef()
    const ProductRef = useRef()
    const GroupRef = useRef()
    const StoreRef = useRef()
    const ParentGroupRef = useRef()
    const [List, setList] = useState([]);
    const [FiscalYearId, setFiscalYearId] = useState(localStorage.getItem("FiscalYearId"));
    const [GroupId, setGroupId] = useState("-1");
    const [GroupParentId, setGroupParentId] = useState("-1");
    const [ProductTitle, setProductTitle] = useState('');
    const [ProductId, setProductId] = useState(General.GuidEmpty());
    const [Code, setCode] = useState("");
    const [StoreRoomId, setStoreRoomId] = useState(-1);
    const [Type, setType] = useState(-1);
    const [IsConfirm, setIsConfirm] = useState(-1);
    const [BeginDate, setBeginDate] = useState(moment(new Date()).add("Day", -7));
    const [EndDate, setEndDate] = useState(moment(new Date()));
    const [expandedRowKeys, setExpandedRowKeys] = React.useState([0]);
    const [loading, setLoading] = React.useState(false)

    //#endregion

    const handleExpanded = (rowData) => {
        let open = false;
        const nextExpandedRowKeys = [];
        expandedRowKeys.forEach(key => {

            if (key === rowData[rowKey]) {
                open = true;
            } else if (key != undefined) {
                nextExpandedRowKeys.push(key);
            }
        });

        if (!open) {
            nextExpandedRowKeys.push(rowData[rowKey]);
        }

        setExpandedRowKeys(nextExpandedRowKeys);
    };

    const Product_Select = (e) => {
        setProductId(e.split("|")[0])
        setProductTitle(e.split("|")[1])
    }

    const Product_Change = (e) => {
        setProductId(General.GuidEmpty())
        if (e.split("|").length > 1) {
            setProductTitle(e.split("|")[1]);
            return;
        }
        setProductTitle(e);
        ProductRef.current.Bind(GroupParentId, GroupId, e)

    }

    const BeginDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setBeginDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const EndDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setEndDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const Parent_Change = (value) => {
        setGroupParentId(value);
        setProductId(General.GuidEmpty());
        setProductTitle("");
        setGroupId("-1");
        GroupRef.current.BindGroupByParentId(0, value);
        ProductRef.current.Bind(value, -1, '')
    }

    const Group_Change = (value) => {
        setGroupId(value);
        setProductId(General.GuidEmpty());
        setProductTitle("");
        ProductRef.current.Bind(GroupParentId, value, '')
    }

    //#region Methods


    const Search = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/StoreRoomReciept/SearchHeader', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'BeginDate': BeginDate != null ? moment(BeginDate.format()).format("jYYYY/jMM/jDD") : "",
                    'EndDate': EndDate != null ? moment(EndDate.format()).format("jYYYY/jMM/jDD") : "",
                    'IsConfirm': IsConfirm,
                    'ProductId': ProductId,
                    'GroupId': GroupId,
                    'GroupParentId': GroupParentId,
                    'FiscalYearId': FiscalYearId,
                    'StoreRoomId': StoreRoomId,
                    'Code': Code,
                    'Type': Type,
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            row: i + 1,
                            id: result[i].id,
                            Price: result[i].price,
                            StoreRoom: result[i].storeRoom,
                            InsertDateTime: result[i].insertDate + " " + result[i].insertTime,
                            Code: result[i].code,
                            InsertUser: result[i].insertUser,
                            IsConfirm: result[i].isConfirm,
                            children: result[i].children,
                            Type: result[i].type,
                            TypeComment: result[i].type == 0 ? "اول دوره" :
                                result[i].type == 1 ? "فاکتور خرید " :
                                    result[i].type == 2 ? "جابه جای بین انبار " :
                                        result[i].type == 3 ? "برگشت از فروش " : "",

                        })
                    }
                    console.dir(tmp);
                    setList(tmp)
                })
        )
    }


    const ShowUpdateConfirm = (id) => {
        console.dir(id)
        UpdateConfirmRef.current.Bind(id)
    }

    const ShowDelete = (id, code) => {
        DeleteRef.current.Get(13, id, code);
    }

    const ShowEdit = (id) => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 13);
        myHeaders.append("Operation", 3);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage("AccessDenied")), 'topCenter')

                    }
                    else {
                        navigate("/InsertReciept")
                        localStorage.setItem("RecieptHeaderId", id)
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )


    }

    const Print = (id) => {
        // navigate("/PrintReciept")
        window.open("/PrintReciept", "_blank");
        localStorage.setItem("RecieptHeaderId", id)
    }

    const ShowNew = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 13);
        myHeaders.append("Operation", 1);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage("AccessDenied")), 'topCenter')
                    }
                    else {
                        navigate("/InsertReciept")
                        localStorage.setItem("RecieptHeaderId", General.GuidEmpty())

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 13);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        Search();
                        ParentGroupRef.current.BindGroupByParentId(-1, 0);
                        StoreRef.current.Bind(-1);
                        StoreRef.current.focus();

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    const handelKeyDown = (e, row) => {
        if (e.key == "Enter") {
            Search();
        }
        if (e.shiftKey && e.code === "KeyN") {
            ShowNew();
        }

    }

    useEffect(() => {
        CheckPermission();
        document.title = "رسید انبار";

    }, [])
    //#endregion


    return (

        <Layout title="رسید انبار">
            <div className="h-100 p-1" onKeyDown={handelKeyDown}>
                <rsuite.Panel className="bg-white ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={Search}>  جستجو</rsuite.Button>
                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={ShowNew}>  جـــدید</rsuite.Button>

                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row className='p-1'>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>انبار</label>
                            <Drp_StoreRoom className='rs-input FocusItem' value={StoreRoomId} onChange={(e) => setStoreRoomId(e)} ref={StoreRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>کد</label>
                            <rsuite.Input value={Code} onChange={(e) => setCode(e)} />
                        </rsuite.Col>

                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label> از تاریخ </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={BeginDate} onChange={BeginDate_Change} />

                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>تا تاریخ </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={EndDate} onChange={EndDate_Change} />
                        </rsuite.Col>

                    </rsuite.Row>
                    <rsuite.Row className='p-1'>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>نوع</label>
                            <select className="rs-input" onChange={(e) => setType(e.target.value)} value={Type}>
                                <option value="-1">انتخاب نمایید</option>
                                <option value="0">اول دوره</option>
                                <option value="1">فاکتور خرید </option>
                                <option value="2">جابه جای بین انبار </option>
                                <option value="3">برگشت از فروش </option>


                            </select>
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label> وضعیت تایید</label>
                            <select className="rs-input" onChange={(e) => setIsConfirm(e.target.value)} value={IsConfirm}>
                                <option value="-1">انتخاب نمایید</option>
                                <option value="0">تایید نشده </option>
                                <option value="1">تمام آیتم ها تایید شده </option>
                                <option value="2">برخی آیتم ها تایید شده </option>


                            </select>
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>گروه   </label>
                            <Drp_ProductParentGroup className="rs-input" value={GroupParentId} onChange={Parent_Change} ref={ParentGroupRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>زیر گروه   </label>
                            <Drp_ProductGroup className="rs-input" value={GroupId} onChange={Group_Change} ref={GroupRef} />
                        </rsuite.Col>

                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <label> محصول   </label>
                            <Auto_Product className="rs-input" value={ProductTitle} onChange={Product_Change} onSelect={Product_Select} ref={ProductRef} />
                        </rsuite.Col>




                    </rsuite.Row>

                    <div className="h-90 p-1">
                        <div className="h-100-y">

                            <rsuite.Panel className="bg-white mt-2">

                                <rsuite.Table
                                    rowKey={rowKey}
                                    // rowExpandedHeight={210}
                                    rowExpandedHeight={rowData => {
                                        return (
                                            rowData.children.length == 1 ? 100 : rowData.children.length * 75)
                                    }}

                                    height={500}
                                    data={List}
                                    expandedRowKeys={expandedRowKeys}
                                    loading={loading}
                                    renderRowExpanded={rowData => {
                                        return (
                                            <div>
                                                <rsuite.Table
                                                    data={rowData.children}
                                                    loading={loading}
                                                    autoHeight={true}
                                                    className='text-black-50'
                                                    wordWrap
                                                >
                                                    {/* <rsuite.Table.Column width={50} align="center"  >
                                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell >
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column> */}
                                                    <rsuite.Table.Column flexGrow={1} fullText resizable>
                                                        <rsuite.Table.HeaderCell>مبنا</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell dataKey='refTitle' />
                                                    </rsuite.Table.Column>

                                                    <rsuite.Table.Column flexGrow={2} fullText resizable>
                                                        <rsuite.Table.HeaderCell>محصول </rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell dataKey='product' />
                                                    </rsuite.Table.Column>


                                                    <rsuite.Table.Column width={100} >
                                                        <rsuite.Table.HeaderCell>تعداد</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell dataKey='count' />
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column flexGrow={1} >
                                                        <rsuite.Table.HeaderCell>قیمت واحد (ریال)</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <>
                                                                        {PN.sliceNumber(rowData.price)}
                                                                    </>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column width={100} >
                                                        <rsuite.Table.HeaderCell>تخفیف (%)</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell dataKey='discountPercent' />
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column flexGrow={1} >
                                                        <rsuite.Table.HeaderCell>تخفیف واحد (ریال)</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <>
                                                                        {PN.sliceNumber(rowData.discountPrice)}
                                                                    </>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column flexGrow={1} >
                                                        <rsuite.Table.HeaderCell>مالیات واحد (ریال)</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <>
                                                                        {PN.sliceNumber(rowData.tax)}
                                                                    </>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column flexGrow={1} >
                                                        <rsuite.Table.HeaderCell>قیمت کل (ریال)</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <>
                                                                        {PN.sliceNumber(rowData.totalPrice)}
                                                                    </>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>
                                                </rsuite.Table>
                                            </div>
                                        );
                                    }}

                                >

                                    <rsuite.Table.Column className="w-10p" align="center" fixed >
                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    {expandedRowKeys.some(key => key === rowData[rowKey]) ? (
                                                        <BiIcon.BiMinusCircle size='12px' color='red' appearance="subtle"
                                                            onClick={() => {
                                                                handleExpanded(rowData);
                                                            }} />
                                                    ) : (
                                                        <BiIcon.BiPlusCircle size='12px' color='green' appearance="subtle"
                                                            onClick={() => {
                                                                handleExpanded(rowData);
                                                            }} />
                                                    )}

                                                    {/* <ExpandCell dataKey="id" expandedRowKeys={expandedRowKeys} onChange={handleExpanded} /> */}
                                                    &nbsp;&nbsp; {rowData.row}
                                                </>


                                            }}

                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>شماره رسید</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Code" />

                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>نوع</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="TypeComment" />

                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>انبار</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="StoreRoom" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>تاریخ</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="InsertDateTime" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>کاربر</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="InsertUser" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>وضعیت   </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>

                                                    {rowData.IsConfirm == 0 ?

                                                        <>تایید نشده</>
                                                        : rowData.IsConfirm == 1 ?
                                                            <>تمام آیتم ها تایید شده </>
                                                            :
                                                            <>برخی آیتم ها تایید شده </>

                                                    }
                                                </>


                                            }}

                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>


                                    <rsuite.Table.Column fixed="right" width={60} >
                                        <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>

                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    <rsuite.Whisper placement="autoVerticalStart" trigger="click" speaker={
                                                        <rsuite.Popover full className='PopoverMenu'>
                                                            <rsuite.Dropdown.Menu  >
                                                                <rsuite.Dropdown.Item className={rowData.IsConfirm == 0 && rowData.Type != 0 && rowData.Type != 1 && rowData.Type != 6 ? '' : "hide"} onClick={() => ShowEdit(rowData.id)}>ویرایش</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item className={rowData.IsConfirm != 1 ? '' : "hide"} onClick={() => ShowUpdateConfirm(rowData.id)}>تایید ورود</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item className={rowData.children == null || rowData.children.length == 0 ? '' : "hide"} onClick={() => ShowDelete(rowData.id, rowData.Code)}>حذف</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item onClick={() => Print(rowData.id)}>چاپ</rsuite.Dropdown.Item>
                                                            </rsuite.Dropdown.Menu>
                                                        </rsuite.Popover>
                                                    }>
                                                        <rsuite.IconButton appearance="subtle" icon={<BiIcon.BiDotsHorizontalRounded />} />
                                                    </rsuite.Whisper>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>
                                </rsuite.Table>

                            </rsuite.Panel>

                        </div>
                    </div>
                    <rsuite.Row>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Divider></rsuite.Divider>
                            <small><b> Shift+N :</b> جدید<b>| Enter :</b> جستجو </small>
                        </rsuite.Col>
                    </rsuite.Row>

                </rsuite.Panel >
            </div >



            <Delete ref={DeleteRef} onSubmit={Search} />
            <Modal_UpdateConfirm ref={UpdateConfirmRef} onSubmit={Search} />
        </Layout >


    )
}

export default RecieptIndex;